/** Strategem 318 (Venom Cloud): fade-in target art on enemy general(s), then dissipate */
export const VENOM_CLOUD_TARGET_IMAGE_PATH = '/images/venom_cloud_target.png';
export const VENOM_CLOUD_SOUND_PATH = '/sounds/venom_cloud.mp3';
/** Time from overlay show until dissipate begins (includes fade-in + brief hold) */
export const VENOM_CLOUD_TARGET_FADE_DURATION_MS = 720;
/** Fade-out / expand / blur duration so the cloud looks like it dissolves */
export const VENOM_CLOUD_TARGET_DISSIPATE_DURATION_MS = 900;
/** Scale applied during dissipate (expands as it fades) */
export const VENOM_CLOUD_TARGET_DISSIPATE_SCALE = 1.4;
